import { publish } from '@insided/deprecated-utils/globals'
import { Author } from '../interfaces'

export interface QuoteProps {
  author: Author
  content: string | null
}

export const onQuoteClick = (author: Author, content: string | null) => {
  publish('quote', {
    username: author.username,
    content: content ?? ''
  })
}

const Quote = ({ author, content, ...restProps }: QuoteProps) => {
    return (
      <div className='post--options-list-container-item'>
        <a {...restProps} onClick={() => onQuoteClick(author, content)}>
          <i className='fa fa-quote-right' /> Quote
        </a>
      </div>
    )
}

export default Quote
